import { onPatientUpdate } from './patient';
import { onFeatureFlagUpdate } from './feature_flags';
import { onImpersonationEnded } from './impersonation';
import { onEligibilityBatchProgress } from './eligibility';
import { onCustomFormUpdate } from './custom_form_response';
import updateSpecialty from './myscribe/lib/updateSpecialty';
import onTransactionCreate from './transaction/onTransactionCreate';
import { onStickyNoteCreate, onStickyNoteDelete } from './sticky_notes';
import { onMyscribeAiAck, onMyscribeAiError, onMyscribeAiResponse } from './myscribe';
import {
  onInsuranceProfileCreate,
  onInsuranceProfileDelete,
  onInsuranceProfileUpdate
} from './insurance_profiles';
import {
  onAppointmentAllergiesUpdate,
  onAppointmentCreate,
  onAppointmentUpdate,
  onCustomChartIdUpdate
} from './appointment';

export default (data) => {
  switch (data?.kind) {
    case 'myscribe-ai-ack':
      onMyscribeAiAck(data);
      break;

    case 'myscribe-ai-error':
      onMyscribeAiError(data);
      break;

    case 'myscribe-ai-response':
      onMyscribeAiResponse(data);
      break;

    case 'appointment-update':
      onAppointmentUpdate(data);
      break;

    case 'appointment-create':
      onAppointmentCreate(data);
      break;

    case 'appointment-allergies-update':
      onAppointmentAllergiesUpdate(data);
      break;
    case 'appointment-chart_id-update':
      onCustomChartIdUpdate(data);
      break;

    case 'patient-update':
      onPatientUpdate(data);
      break;

    case 'sticky-note-create':
      onStickyNoteCreate(data);
      break;

    case 'sticky-note-delete':
      onStickyNoteDelete(data);
      break;

    case 'custom-form-update':
      onCustomFormUpdate(data);
      break;

    case 'insurance-profile-create':
      onInsuranceProfileCreate(data);
      break;

    case 'insurance-profile-update':
      onInsuranceProfileUpdate(data);
      break;

    case 'insurance-profile-delete':
      onInsuranceProfileDelete(data);
      break;
    case 'feature-flag-update':
      onFeatureFlagUpdate(data);
      break;
    case 'transaction-create':
      onTransactionCreate(data);
      break;
    case 'get-specialty':
      updateSpecialty(data);
      break;

    case 'eligibility-batch-progress':
      onEligibilityBatchProgress(data);
      break;

    case 'impersonation-ended':
      onImpersonationEnded();
      break;

    default:
      break;
  }
};
